// extracted by mini-css-extract-plugin
export default {"button":"marvelButton_button__GJ6fZ"};